function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBag2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 410",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-32.262,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0485,0,0,1.0489,-9.66384,-12.4626)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.976,
    y: 116.857,
    width: 309.607,
    height: 274.217,
    style: {
      fill: "rgba(170, 209, 42, 0.2)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.099,116.515C259.586,116.515 263.228,112.882 263.228,108.386C263.228,103.891 259.586,100.257 255.099,100.257L143.486,100.257C138.999,100.257 135.357,103.89 135.357,108.386C135.357,112.881 138.999,116.515 143.486,116.515L255.099,116.515Z",
    style: {
      fill: "rgb(170,209,42)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.062,100.258L311.69,100.258C307.203,100.258 303.561,103.891 303.561,108.387C303.561,112.882 307.203,116.516 311.69,116.516L358.933,116.516L358.933,391.197L48.519,391.197L48.519,116.515L93.055,116.515C97.542,116.515 101.184,112.882 101.184,108.386C101.184,103.891 97.542,100.257 93.055,100.257L40.391,100.257C35.904,100.257 32.262,103.89 32.262,108.386L32.262,399.324C32.262,403.819 35.904,407.453 40.391,407.453L367.062,407.453C371.549,407.453 375.191,403.82 375.191,399.324L375.191,108.386C375.191,103.891 371.557,100.258 367.062,100.258Z",
    style: {
      fill: "rgb(170,209,42)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.59,134.796C287.077,134.796 290.719,131.163 290.719,126.667L290.719,67.394C290.718,30.238 250.604,0 201.101,0C151.793,0 111.687,30.238 111.687,67.394L111.687,126.668C111.687,131.163 115.329,134.797 119.816,134.797C124.303,134.797 127.945,131.164 127.945,126.668L127.945,67.394C127.945,39.196 160.768,16.257 201.305,16.257C241.639,16.257 274.462,39.196 274.462,67.394L274.462,126.668C274.461,131.163 278.095,134.796 282.59,134.796Z",
    style: {
      fill: "rgb(170,209,42)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.892,147.566C98.892,159.092 108.281,168.473 119.815,168.473C131.349,168.473 140.738,159.093 140.738,147.566C140.738,143.071 137.096,139.437 132.609,139.437C128.122,139.437 124.48,143.07 124.48,147.566C124.48,150.127 122.391,152.216 119.814,152.216C117.245,152.216 115.148,150.127 115.148,147.566C115.148,143.071 111.506,139.437 107.019,139.437C102.532,139.437 98.892,143.071 98.892,147.566Z",
    style: {
      fill: "rgb(170,209,42)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.59,168.473C294.124,168.473 303.513,159.093 303.513,147.566C303.513,143.071 299.871,139.437 295.384,139.437C290.897,139.437 287.255,143.07 287.255,147.566C287.255,150.127 285.166,152.216 282.589,152.216C280.012,152.216 277.923,150.127 277.923,147.566C277.923,143.071 274.281,139.437 269.794,139.437C265.307,139.437 261.665,143.07 261.665,147.566C261.667,159.092 271.055,168.473 282.59,168.473Z",
    style: {
      fill: "rgb(170,209,42)",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag2);
export default __webpack_public_path__ + "static/media/shopping-bag2.861f1962.svg";
export { ForwardRef as ReactComponent };